var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBell = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 20,
  viewBox: "0 0 21 20",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.6519 6.66602C15.6519 5.33993 15.1022 4.06816 14.1237 3.13048C13.1453 2.1928 11.8182 1.66602 10.4345 1.66602C9.05075 1.66602 7.72368 2.1928 6.74523 3.13048C5.76678 4.06816 5.21709 5.33993 5.21709 6.66602C5.21709 12.4993 2.6084 14.166 2.6084 14.166H18.2606C18.2606 14.166 15.6519 12.4993 15.6519 6.66602Z",
  stroke: "#666666",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9394 17.5C11.7865 17.7526 11.567 17.9622 11.303 18.1079C11.039 18.2537 10.7397 18.3304 10.435 18.3304C10.1303 18.3304 9.831 18.2537 9.56699 18.1079C9.30297 17.9622 9.08354 17.7526 8.93066 17.5",
  stroke: "#666666",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBell, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bell.8f15840a.svg";
export { ForwardRef as ReactComponent };